import React, {useEffect, useState} from "react";
import {Button, Form, Modal} from "antd";
import SharedService from "../../../../services/shared/service";
import SupplierAutoComplete from "../../../AutoComplete/Supplier/SupplierAutoComplete";

const ReprocessInvoiceModal = ({visible, onCancel, disableStatus, documentId, user, supplier = null}) => {
    const [form] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (visible) {
            form.setFieldsValue({supplierId: supplier?.id ?? null});
        }
    }, [visible, supplier, form]);

    const handleCancel = () => {
        form.resetFields();
        onCancel?.();
    };

    const handleSubmit = async () => {
        try {
            const values = await form.validateFields();
            setIsLoading(true);
            await SharedService.post({
                token: user.token,
                data: {supplierId: values.supplierId},
                url: `invoice/reprocess/${documentId}`,
            });
            onCancel?.();
            window.location.reload();
        } catch (errorInfo) {
            console.error("ReprocessInvoiceForm Error:", errorInfo);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            title="Reprocess Invoice"
            open={visible}
            onCancel={handleCancel}
            closable={true}
            width={520}
            footer={[
                <Button key="cancel" onClick={handleCancel} disabled={isLoading}>
                    Cancel
                </Button>,
                <Button
                    key="submit"
                    type="primary"
                    loading={isLoading}
                    onClick={handleSubmit}
                    disabled={!disableStatus}
                >
                    Reprocess
                </Button>,
            ]}
        >
            <Form form={form} layout="vertical" requiredMark={false}>
                <Form.Item
                    name="supplierId"
                    rules={[{required: true, message: "Supplier is required"}]}
                    label={
                        <span className="text-[12px] font-semibold text-[#7A849A] uppercase tracking-wide">
                            Supplier <span style={{color: "#A4231D"}}>*</span>
                        </span>
                    }
                >
                    <SupplierAutoComplete
                        user={user}
                        supplier={supplier}
                        onSelectSupplier={(option) => {
                            form.setFieldsValue({
                                supplierId: option?.value,
                                supplierName: option?.label,
                            });
                        }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ReprocessInvoiceModal;
